import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import ContentRow from './ContentRow';
import styles from './ContentTable.module.css';

const ContentTable = ({
  articles,
  setArticles,
  selectedCategory,
  selectedMonetizeType,
}) => {
  const currCode = useSelector(
    (state) => state.user.publisher?.bookCurrency?.code
  );

  let contentBody = articles.map(
    ({ title, price, category, tipJarPrice, isChecked, id, monetizeType }) => (
      <ContentRow
        postTitle={title}
        price={price}
        tipJarPrice={tipJarPrice}
        monetizeType={monetizeType}
        category={category}
        isChecked={isChecked}
        id={id}
        setArticles={setArticles}
      />
    )
  );

  // this check if the selected catergory is not none;
  if (selectedCategory.name !== 'none') {
    contentBody = articles
      .filter(({ category }) => category === selectedCategory.name)
      .map(
        ({
          title,
          price,
          category,
          tipJarPrice,
          isChecked,
          id,
          monetizeType,
        }) => (
          <ContentRow
            postTitle={title}
            price={price}
            tipJarPrice={tipJarPrice}
            monetizeType={monetizeType}
            category={category}
            isChecked={isChecked}
            id={id}
            setArticles={setArticles}
          />
        )
      );
  }

  return (
    <table className={styles.content__table}>
      <thead className={styles.thead}>
        <tr>
          <th scope="col" className={styles.title}>
            Post title
          </th>
          <th scope="col" className={styles.paywall}>
            {selectedMonetizeType}
          </th>
          {selectedMonetizeType === 'paywall' && (
            <th scope="col" className={styles.price}>
              price
              <span className={styles.currency}>({currCode})</span>
            </th>
          )}
          {selectedMonetizeType === 'tipjar' && [
            <th scope="col" className={styles.price}>
              low
              <span className={styles.currency}>({currCode})</span>
            </th>,
            <th scope="col" className={styles.price}>
              med
              <span className={styles.currency}>({currCode})</span>
            </th>,
            <th scope="col" className={styles.price}>
              high
              <span className={styles.currency}>({currCode})</span>
            </th>,
          ]}
          <th scope="col" className={styles.category}>
            Category
          </th>
        </tr>
      </thead>
      <tbody className={styles.tbody}>{contentBody}</tbody>
    </table>
  );
};

ContentTable.propTypes = {
  articles: PropTypes.node.isRequired,
  setArticles: PropTypes.node.isRequired,
  selectedCategory: PropTypes.node.isRequired,
  selectedMonetizeType: PropTypes.node.isRequired,
};

export default ContentTable;
